import React, { useState } from 'react';
import useDms from '../../hooks/useDms';
import { Loading, ErrorBox, Empty } from './shared';
import Pager from '../LiveIntel/Pager';
import { nfmt, compactUsd } from '../../lib/formatters';

export default function ReportsBoxscores() {
  const [draft, setDraft] = useState('');
  const [applied, setApplied] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(40);

  const { data, loading, error } = useDms('datasets/boxscores_2026', {
    q: applied,
    limit: perPage,
    offset: (page - 1) * perPage,
  });

  const submit = (e) => {
    e.preventDefault();
    setApplied(draft);
    setPage(1);
  };

  const total = data?.total ?? 0;

  return (
    <div className="lyve-intel">
      <div className="hero" style={{ paddingBottom: 0 }}>
        <div className="eyebrow">
          <i />
          REPORTS · BOX SCORES
        </div>
        <h1 className="h-title wide">2026 BOX SCORES</h1>
        <p className="h-sub">
          Every 2026 show run from the Master Document — event dates, artist, gross, tickets, capacity and sell-through.
        </p>
      </div>

      <div className="page" style={{ paddingTop: 18 }}>
        <form className="acat-bar" onSubmit={submit}>
          <input
            className="acat-input"
            placeholder="Artist or venue"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
          <button className="acat-go" type="submit">
            Search
          </button>
        </form>

        {loading && <Loading />}
        {error && <ErrorBox error={error} />}
        {!loading && !error && data?.data?.length === 0 && <Empty label="No box scores found." />}
        {!loading && !error && data?.data?.length > 0 && (
          <>
            <div className="fs-meta">
              <span className="num">{nfmt(total)}</span> <span className="faint">rows</span>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Artist</th>
                  <th>Venue</th>
                  <th>City</th>
                  <th>Country</th>
                  <th>Revenue</th>
                  <th>Tickets</th>
                  <th>Capacity</th>
                  <th>Sell-through</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((b, i) => (
                  <tr key={i}>
                    <td>{b.event_date}</td>
                    <td>{b.artist}</td>
                    <td>{b.venue}</td>
                    <td>{b.city}</td>
                    <td>{b.country}</td>
                    <td>{compactUsd(b.revenue_usd)}</td>
                    <td>{nfmt(b.tickets_sold)}</td>
                    <td>{nfmt(b.capacity)}</td>
                    <td>{b.sell_through == null ? '—' : `${(Number(b.sell_through) * 100).toFixed(0)}%`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pager
              total={total}
              page={page}
              perPage={perPage}
              onPage={setPage}
              onPerPage={(v) => {
                setPerPage(v);
                setPage(1);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
